import api from '@/utils/api';

/**
 * get customer api
 *
 * @param {string} customerId The customer id
 * @returns {Promise} The promise object of the api call
 */
const getCustomerApi = (customerId) => api.get(`customer/${customerId}`);
export default getCustomerApi;
